import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const e = a((s, c) => /* @__PURE__ */ l.jsx(
  i,
  {
    ref: c,
    ...s,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 91,
        height: 100,
        fill: "none",
        viewBox: "0 0 91 100",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M73.168 75.01c-.09.21-.17.43-.27.64-4.93 11.21-13.47 19.57-22.82 22.35-2.33.69-6.26.69-8.59 0-9.36-2.78-17.89-11.14-22.83-22.35-.09-.21-.18-.43-.27-.64-.07 1.1-.1 2.24-.1 3.4 5.22 10.52 13.6 18.3 22.76 21.02 1.3.39 3.01.58 4.72.58s3.42-.19 4.72-.58c9.18-2.73 17.57-10.54 22.76-21.03 0-1.17-.03-2.3-.1-3.4z"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M45.788 85.54c1.22 0 2.43-.46 3.36-1.39l2.28-2.28-.99-.99-2.28 2.28c-1.3 1.3-3.42 1.3-4.73 0l-2.28-2.28-.99.99 2.28 2.28c.93.93 2.14 1.39 3.36 1.39zM53.078 90.82l-.55-1.29c-6.64 2.85-13.41.03-13.47 0l-.55 1.29c.2.08 3.34 1.4 7.53 1.4 2.16 0 4.6-.35 7.05-1.4zM38.068 60.07l.81-1.26c-2.53-1.64-9.7-3.7-14.83-2.74-.36.59-.71 1.2-1.05 1.82 4.35-1.58 12.16.29 15.07 2.18M38.468 64.7l-.8-1.16c-6.02 4.17-11.97.17-12.22 0l-.8 1.16s3.12 2.11 7.19 2.11c2.05 0 4.35-.53 6.63-2.11M52.688 58.81l.81 1.26c2.91-1.88 10.72-3.76 15.07-2.18-.34-.62-.69-1.23-1.05-1.82-5.13-.96-12.3 1.1-14.83 2.74M66.928 64.7l-.8-1.16c-.25.17-6.21 4.17-12.22 0l-.8 1.16c2.29 1.58 4.58 2.11 6.63 2.11 4.07 0 7.14-2.08 7.19-2.11"
            }
          ),
          /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M89.558 43.66C85.638 16.28 67.948 0 45.788 0S5.938 16.28 2.018 43.66c-1.79 12.49-1.23 32.4-.24 40.22 1.1 8.78 19.05 13.49 19.05 13.49-1.75-7.17-2.52-13.44-2.52-18.95 0-1.17.03-2.3.1-3.4.41-6.9 2.11-12.51 4.59-17.11.34-.62.69-1.23 1.05-1.82 5.57-8.98 14.24-13.89 21.74-17.41 7.5 3.52 16.17 8.43 21.74 17.4.37.59.71 1.2 1.05 1.82 2.49 4.61 4.18 10.21 4.59 17.11.07 1.1.1 2.23.1 3.4 0 5.51-.77 11.79-2.52 18.96 0 0 17.95-4.71 19.05-13.49.99-7.82 1.55-27.73-.24-40.22m-31.93-18.83c-6.01-.54-9.62.62-11.82 2.47 3.03 0 7.74-.8 11.24 3.15-4.24-.53-7.04-.53-10.85.14 2.4 0 5.41 1.98 6.01 2.91-1.49-.7-4.55-.67-6.61.45.89 0 2.65.56 3.24 1.12-.83.56-1.76 1.12-3.03 1.68-2.01-.54-3.43-1.68-4.32-2.8 1.1-1 3.41-1.71 4.71-2.08-2.65-1.28-6.76-1.28-8.52-.54 1.7-3.08 3.68-4.69 7.31-6.11-3.52-.43-4.44-.47-7.31.65 1.17-.99 3.86-2.31 6.46-2.47-4.11-.49-5.87-.49-9.39.99 2.47-2.8 4.68-4.05 10.25-5.54-2.69-1.98-6.73-2.29-9.98-1.16 5.02-4.27 11.19-5.45 11.19-5.45-3.01-1.63-5.41-1.53-8.42-.99 2.41-1.08 3.61-2.17 7.21-2.17-.6-.54-2.41-1.08-3.75-1.01.74-.62 2.34-1.16 3.75-1.16-1.41-.54-2.41-.54-3.75-.44 1.3-1.68 2.6-2.8 4.56-3.36 1.6.54 3.6 1.68 5.04 3.36-1.03-.1-3.75.37-5.24 1.6 2.6-.4 6.01-.62 7.21.47 0 0-2.54.62-3.98 2.49 2.81.3 5.61 1.06 7.04 2.39-3.67 0-5.67-.12-8.9 2.67 5-.73 8.24.59 11.25 2.76-3.61-.54-6.66-.12-10.27 2.05 5.41 0 8.23 2.51 9.67 3.92z"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "HairLossFemale2Icon";
export {
  e as HairLossFemale2Icon,
  e as default
};
//# sourceMappingURL=index.js.map
